import * as yup from 'yup';

import { ObjectTypeBase } from '../../baseTypes/ObjectTypeBase';
import { PropertiesInterface } from '../Property';
import { TypeContextEnum } from '../TypeContextEnum';
import { Types } from '../Types';
import { TYPE_GROUP_LANE } from '../constants';
import { createShapeFromProperties } from '../createShapeFromProperties';

const properties: PropertiesInterface = {
  _id: {
    type: 'UUID',
    validators: [
      {
        name: 'Required',
        value: true,
      },
    ],
  },
};

export class BlockType extends ObjectTypeBase {
  group = TYPE_GROUP_LANE;

  name = 'Block';

  friendlyName = 'Block';

  contexts = [TypeContextEnum.Block, TypeContextEnum.Content];

  superUserOnly = false;
  properties = properties;

  get default(): any {
    return {
      _id: null,
    };
  }

  buildSchema() {
    return yup
      .object()
      .nullable()
      .default(null)
      .shape(createShapeFromProperties(properties));
  }
}

const definition = new BlockType();

Types.addBaseType(definition);

export { definition as BlockDefinition };
